import { jsxs as n, jsx as i } from "react/jsx-runtime";
import t from "./styles.module.less.js";
import h from "./arrow-left.svg.js";
import B from "./arrow-right.svg.js";
const b = (r) => {
  const {
    showArrows: e,
    classNames: o,
    disabledLeftButton: a,
    disabledRightButton: c,
    onLeftButtonClick: l,
    onRightButtonClick: s,
    scrollWidth: d,
    leftPosition: m
  } = r;
  return /* @__PURE__ */ n("div", { className: `${t.actionBar}  ${(o == null ? void 0 : o.actionBar) ?? ""}`, children: [
    /* @__PURE__ */ i("div", { className: t.scrollBar, children: /* @__PURE__ */ i(
      "div",
      {
        className: t.scrolledPosition,
        style: {
          width: `${d * 100}%`,
          left: `${m}%`
        }
      }
    ) }),
    /* @__PURE__ */ n(
      "div",
      {
        className: `${t.actionButtonContainer} ${(o == null ? void 0 : o.arrowButtonContainer) ?? ""} ${e ? "" : t.hidden}`,
        children: [
          /* @__PURE__ */ i(
            "button",
            {
              className: t.actionButton,
              onClick: l,
              disabled: a,
              children: /* @__PURE__ */ i(h, { className: t.actionIcon })
            }
          ),
          /* @__PURE__ */ i(
            "button",
            {
              className: t.actionButton,
              disabled: c,
              onClick: s,
              children: /* @__PURE__ */ i(B, { className: t.actionIcon })
            }
          )
        ]
      }
    )
  ] });
};
export {
  b as ProgressBarComponent
};
